import React, { Component } from "react";
import * as d3 from "d3";
import $ from "jquery";
import PropTypes from "prop-types";
import "./pie.css";

class pie extends Component {
  state = {
    margin: { top: 10, right: 10, bottom: 10, left: 10 },
  };

  componentDidMount() {
    this.drawPie(this.props);
  }
  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data) ||
      this.props.width !== nextProps.width
    ) {
      $(`#${this.props.id}`).empty();
      this.drawPie(nextProps);
    }
  }

  drawPie = (props) => {
    const { margin } = this.state;
    const { data, id, height, width, color1, color2 } = props;
    const radius = Math.min(width, height) / 2 - 15;
    var svg = d3
      .select(`#${id}`)
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .attr(
        "viewBox",
        `0 0 ${width + margin.left + margin.right} ${
          height + margin.top + margin.bottom
        }`
      )
      .append("g");

    svg.append("g").attr("class", "pie-slices");
    svg.append("g").attr("class", "pie-labels");
    svg.append("g").attr("class", "pie-lines");
    svg.append("g").attr("class", "pie-centroid");

    var pie = d3.layout
      .pie()
      .sort(null)
      .value((d) => d.value);

    var arc = d3.svg
      .arc()
      .outerRadius(radius * 0.8)
      .innerRadius(0);

    var outerArc = d3.svg
      .arc()
      .innerRadius(radius * 0.9)
      .outerRadius(radius * 0.9);

    svg.attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

    var key = (d) => d.data.label;

    let interpolate = d3.interpolateRgb(color1, color2);

    change(data);

    function change(data) {
      /* ------- PIE SLICES -------*/

      var slice = svg
        .select(".pie-slices")
        .selectAll("path.slice")
        .data(pie(data), key);

      slice
        .enter()
        .insert("path")
        .style("fill", function (d, i) {
          return interpolate(i / data.length);
        })
        .attr("class", "slice")
        .append("title")
        .text((d) => d.data.label);

      slice
        .transition()
        .duration(1000)
        .attrTween("d", function (d) {
          this._current = this._current || d;
          var interpolate = d3.interpolate(this._current, d);
          this._current = interpolate(0);
          return function (t) {
            return arc(interpolate(t));
          };
        });

      slice.exit().remove();

      /*-----------CENTROID --------*/

      var centroidCircle = svg
        .select(".pie-centroid")
        .selectAll("circle")
        .data(pie(data), key);

      centroidCircle.enter().append("circle");

      centroidCircle
        .attr("class", "eachCentroid")
        .attr("transform", function (d) {
          return "translate(" + arc.centroid(d) + ")";
        })
        .attr("cx", "0")
        .attr("cy", "0")
        .attr("r", "2");

      centroidCircle.exit().remove();

      /* ------- TEXT LABELS -------*/

      var text = svg
        .select(".pie-labels")
        .selectAll("text")
        .data(pie(data), key);

      text
        .enter()
        .append("text")
        .attr("class", "pie-text")
        .attr("dy", ".35em")
        .style("font-size", "12px")
        .style("fill", "#252474")
        .style("font-weight", "bold")
        .text((d) => d.data.label);

      function midAngle(d) {
        return d.startAngle + (d.endAngle - d.startAngle) / 2;
      }

      text
        .transition()
        .duration(1000)
        .attrTween("transform", function (d) {
          this._current = this._current || d;
          var interpolate = d3.interpolate(this._current, d);
          this._current = interpolate(0);
          return function (t) {
            var d2 = interpolate(t);
            var pos = outerArc.centroid(d2);
            pos[0] = radius * (midAngle(d2) < Math.PI ? 1 : -1);
            return "translate(" + pos + ")";
          };
        })
        .styleTween("text-anchor", function (d) {
          this._current = this._current || d;
          var interpolate = d3.interpolate(this._current, d);
          this._current = interpolate(0);
          return function (t) {
            var d2 = interpolate(t);
            return midAngle(d2) < Math.PI ? "start" : "end";
          };
        });

      text.exit().remove();

      /* ------- SLICE TO TEXT POLYLINES -------*/

      var polyline = svg
        .select(".pie-lines")
        .selectAll("polyline")
        .data(pie(data), key);

      polyline
        .enter()
        .append("polyline")
        .style("fill", "none")
        .style("stroke-width", ".8")
        .style("stroke", "#252474");

      polyline
        .transition()
        .duration(1000)
        .attrTween("points", function (d) {
          this._current = this._current || d;
          var interpolate = d3.interpolate(this._current, d);
          this._current = interpolate(0);
          return function (t) {
            var d2 = interpolate(t);
            var pos = outerArc.centroid(d2);

            pos[0] = radius * 0.95 * (midAngle(d2) < Math.PI ? 1 : -1);
            return [arc.centroid(d2), outerArc.centroid(d2), pos];
          };
        });

      polyline.exit().remove();
    }
  };
  render() {
    return <div id={this.props.id} />;
  }
}

pie.prototypes = {
  id: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  color1: PropTypes.string.isRequired,
  color2: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default pie;



// WEBPACK FOOTER //
// ./src/components/d3Components/NewPieChart/pie.jsx